"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSchemaV2 = exports.isStoryBrokenV2 = exports.isStoryBroken = exports.getValidationError = exports.isStoryValid = void 0;
const story_1 = require("./story");
const isStoryValid = (story) => {
    return story_1.storySchema.isValidSync(story);
};
exports.isStoryValid = isStoryValid;
const getValidationError = (story) => {
    if ((0, exports.isStoryValid)(story)) {
        return undefined;
    }
    try {
        story_1.storySchema.validateSync(story);
        // should never get here
        return undefined;
    }
    catch (e) {
        return e;
    }
};
exports.getValidationError = getValidationError;
// export const validateNavigation = (story: DialogModule) => {
//   return testStepsNavigation(story.initialStep).validateSync(story.steps);
// }
// export const isCharacterdIdValid = (possiblyCharId: string): boolean => {
//   return characterId.isValidSync(possiblyCharId);
// }
// Export V1
var validation_1 = require("../v1/validation");
Object.defineProperty(exports, "isStoryBroken", { enumerable: true, get: function () { return validation_1.isStoryBroken; } });
// @NOTE: This might have to be updated as needed
const storyConfig = {
    charSlots: 3,
    propsLength: 6,
};
const isStoryBrokenV2 = (story) => {
    try {
        if (Object.keys(story).length !== storyConfig.propsLength) {
            return true;
        }
        if (Object.keys(story.charSlots).length !== storyConfig.charSlots) {
            return true;
        }
        return false;
    }
    catch (_a) {
        return true;
    }
};
exports.isStoryBrokenV2 = isStoryBrokenV2;
const isSchemaV2 = (story) => Number(story.metadata.version) > 12;
exports.isSchemaV2 = isSchemaV2;
//# sourceMappingURL=validation.js.map